<template>

<div tabindex="0" class="e-card" id="price">
    <div class="e-card-title transaction-edit" style="display: inline-block">Edit Transaction</div>
      <div v-if="selectedInvoice">
        <div class="e-card-content">
        <div class="container2">
            <div class="leftcol">
                <div class="form-row" style="display:none;" >
                    <div class="form-row-input">
                    Invoice ID: {{invoiceId}}
                    </div>
                </div>
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>Invoice Number:</h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                        <h5>{{selectedInvoice.invoiceNumber}}</h5>
                    </div>
                </div>
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>Invoice Date:</h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                        <h5>{{getDateStringNoTime(selectedInvoice.invoiceDate)}}</h5>
                    </div>
                </div>
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>Total Invoice Amount:</h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                      <h5>
                      {{ format_currency(selectedInvoice.totalAppFee
                      + selectedInvoice.totalLevy
                      + selectedInvoice.totalTankFee) }}
                      </h5>
                    </div>
                </div>
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>Invoice Status:</h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                        <h5>{{selectedInvoice.invoiceStatus}}</h5>
                    </div>
                </div>
            </div>
            <div class="middlecol">
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>Applicant Name:</h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                        <h5>{{requestor}}</h5>
                    </div>
                </div>
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>Applicant Company:</h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                        <h5>{{selectedInvoice.applicationRequest.company}}</h5>
                    </div>
                </div>
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>Reference/PO #: </h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                        <h5>{{selectedInvoice.referencePO}}</h5>
                    </div>
                </div>
                <div class="colrow data-flex-row">
                    <div style="width:35%;" class="data-flex-cell">
                        <h4>User Payment Type:</h4>
                    </div>
                    <div style="width:45%;" class="data-flex-cell">
                        <h5>{{selectedInvoice.userPaymentType}}</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="container2">
            <div class="leftcol">
                <div class="form-row colrow">
                    <div style="width:100%;" class="form-row-input">
                        <ejs-dropdownlist
                        float-label-type="Always"
                        :dataSource='paymentTypeOptions'
                        placeholder='Payment Type'
                        v-model='selectedInvoice.paymentType' >
                        </ejs-dropdownlist>
                    </div>
                </div>

                <div class="form-row colrow">
                    <div style="width:100%;" class="form-row-input"  v-if="isPayingByCreditCard">
                        <ejs-dropdownlist
                        float-label-type="Always"
                        :dataSource='paymentMethodOptions'
                        placeholder='Payment Method'
                        v-model='selectedInvoice.paymentMethod' >
                        </ejs-dropdownlist>
                    </div>
                </div>

                <div class="form-row colrow">
                    <div style="width:100%;" class="form-row-input">
                        <ejs-textbox
                        float-label-type="Always"
                        placeholder="Transaction Number"
                        v-model="selectedInvoice.transactionNumber"
                        />
                    </div>
                </div>
                <div class="form-row colrow"  v-if="selectedInvoice.totalPaymentAmount != null">
                    <div style="width:100%;" class="form-row-input">
                        <ejs-numerictextbox
                        float-label-type="Always"
                        placeholder="Total Payment Amount"
                        format = 'C2'
                        :showSpinButton='numericSpin'
                        v-model="selectedInvoice.totalPaymentAmount" />
                    </div>
                </div>
                <div class="form-row colrow" v-if="selectedInvoice.totalPaymentAmount === null">
                    <div style="width:100%;" class="form-row-input">
                        <ejs-numerictextbox
                        float-label-type="Always"
                        placeholder="Total Payment Amount"
                        format = 'C2'
                        id="totalpaymentamount"
                        :showSpinButton='numericSpin'
                        :value="selectedInvoice.totalPaymentAmount"
                         v-model="paymentamt"/>
                    </div>
                </div>
                <div class="form-row colrow">
                    <div style="width:100%;" class="form-row-input">
                        <ejs-datepicker
                        float-label-type="Always"
                        v-model="selectedInvoice.cancelRefundMetDate"
                        :placeholder="dateMarker"
                        :format="dateFormat"/>
                    </div>
                </div>
            </div>
            <div class="left-grid">
              <div class="form-row" style="align:left">
                <div class="form-row-input"
                v-if="selectedInvoice.applicationRequest.internalNotes != null"
                  style="width:100%;align:right;font-size:11px;text-align:left">
                  <fieldset class="disabled-text">
                    <legend>
                      Internal Comments:
                    </legend>
                    <ejs-textbox float-label-type="Always" :readonly="true"
                      v-model="selectedInvoice.applicationRequest.internalNotes"
                      multiline="true" rows=5 />
                  </fieldset>
                </div>
              </div>
                 <div class="align-right">
                  <span style="font-size:11px;text-align:left">
                    Created By: {{selectedInvoice.createUser}}&nbsp;
                      {{getDateTime(selectedInvoice.invoiceDate)}}<br>
                    Updated By: {{selectedInvoice.lastUpdateUser}}&nbsp;
                      {{getDateTime(selectedInvoice.lastUpdatedDate)}}
                  </span>
                </div>
            </div>
        </div>
        <div class="align-center-bottom">
          <ejs-button
          type="button"
          v-on:click.native="onUpdateClick"
          cssClass="e-info margin-button disabled"
          :disabled="isUpdateButtonDisabled">
          Update Payment Type
          </ejs-button>

          <ejs-button
          type="button"
          v-on:click.native="onProcessClick"
          cssClass="e-info margin-button disabled"
          :disabled="isProcessButtonDisabled">
          Process Payment
          </ejs-button>

          <ejs-button
          v-on:click.native="onCancelClick"
          cssClass="e-danger margin-button">
          Cancel
          </ejs-button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import {
  FETCH_INVOICE_BY_ID,
  FETCH_ACCOUNTING_PAYMENT_TYPES,
  FETCH_ACCOUNTING_CREDITCARD_TYPES,
  PROCESS_INVOICE_APPROVE,
  PROCESS_INVOICE_RESET_PAYMENT_TYPE,
} from '../store';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(ButtonPlugin);
export default {
  name: 'transactionEdit',
  components: {
  },

  data() {
    return {
      invoiceId: null,
      title: 'Edit Transaction',
      dateMarker: 'Payment Date(yyyy-mm-dd)',
      dateFormat: 'yyyy-MM-dd',
      datePaid: null,
      paymentTypeOptions: [],
      paymentMethodOptions: [],
      numericSpin: false,
    };
  },

  created() {
    if (this.$route.params.id !== '0') {
      this.invoiceId = this.$route.params.id;
    } else {
      this.invoiceId = '';
    }
  },

  mounted() {
    if (this.invoiceId !== null && this.invoiceId !== '') {
      this.getSelectedInvoice(this.invoiceId);
    }

    this.getPaymentTypes();
  },

  computed: {
    isPayingByCreditCard() {
      return this.selectedInvoice.paymentType === 'Credit Card';
    },
    requestor() {
      return this.selectedInvoice.applicationRequest?.requestor;
    },
    selectedInvoice() {
      return this.$store.getters.accountingSelectedInvoice;
    },
    isProcessButtonDisabled() {
      return this.selectedInvoice.paymentType === 'Credit Card'
      || (!this.selectedInvoice.cancelRefundMetDate
      && !this.selectedInvoice.transactionNumber);
    },
    isUpdateButtonDisabled() {
      return this.selectedInvoice.cancelRefundMetDate || this.selectedInvoice.transactionNumber;
    },
    paymentamt: {
      get() {
        return this.selectedInvoice.totalAppFee
        + this.selectedInvoice.totalLevy
        + this.selectedInvoice.totalTankFee;
      },
      set(val) {
        return val;
      },
    },
  },

  methods: {
    format_currency(val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter.format(val);
    },
    async getPaymentTypes() {
      await this.$store.dispatch(FETCH_ACCOUNTING_PAYMENT_TYPES);
      this.paymentTypeOptions = this.$store.getters.accountingPaymentTypes;
      this.paymentTypeOptions.push('');

      await this.$store.dispatch(FETCH_ACCOUNTING_CREDITCARD_TYPES);
      this.paymentMethodOptions = this.$store.getters.accountingCreditCardTypes;
    },

    async getSelectedInvoice(id) {
      await this.$store.dispatch(FETCH_INVOICE_BY_ID, {
        invoiceId: id,
      });
    },
    async onProcessClick() {
      let errorMessages = '';
      const invoice = this.selectedInvoice;
      this.isError = false;
      // eslint-disable-next-line indent
      if (invoice.cancelRefundMetDate === null || invoice.cancelRefundMetDate === '') {
        errorMessages += 'Payment Date is required.<br>';
        this.isError = true;
      }
      if (invoice.paymentType === null || invoice.paymentType === '') {
        errorMessages += 'Payment Type is required.';
        this.isError = true;
      }
      if (this.isError) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessages,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }
      } else {
        try {
          await this.$store.dispatch(PROCESS_INVOICE_APPROVE, { data: invoice }).then(() => {
            this.$parent.notificationToasts.push({
              title: 'Success!',
              content: 'Transaction Approved successfully.',
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
          });
        } catch (error) {
          this.$parent.notificationToasts.push({
            title: 'Error!',
            content: error.message,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }

        this.$router.push('/accounting/manage-accounting');
      }
    },
    async onUpdateClick() {
      let errorMessages = '';
      const invoice = this.selectedInvoice;
      this.isError = false;

      if (invoice.paymentType === null || invoice.paymentType === '') {
        errorMessages += 'Payment Type is required.';
        this.isError = true;
      }
      if (this.isError) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessages,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }
      } else {
        try {
          await this.$store.dispatch(PROCESS_INVOICE_RESET_PAYMENT_TYPE,
            { data: invoice }).then(() => {
            this.$parent.notificationToasts.push({
              title: 'Success!',
              content: ' Invoice Payment Type Updated successfully.',
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
          });
          this.$router.push('/accounting/manage-accounting');
        } catch (error) {
          this.$parent.notificationToasts.push({
            title: 'Error!',
            content: error.response.data.message,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }
      }
    },
    onCancelClick() {
      this.$router.push('/accounting/manage-accounting');
    },
    getDateStringNoTime(d) {
      if (d !== null && d !== undefined) {
        const d2 = new Date(d);
        return `${d2.getFullYear()}/${d2.getMonth() + 1}/${d2.getDate()}`;
      }
      return null;
    },
    getDateTime(d) {
      if (d !== null && d !== undefined) {
        const d2 = new Date(d);
        return d2.toLocaleString();
      }
      return null;
    },
  },

};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 .e-card-content {
  margin: 0% !important;
}

.transaction-edit .container2 {
  display: flex;
  flex-flow: row;
  min-height: 50px;
  text-align: left;
  border-style: groove;
  border: thin solid silver;
  margin: 10px;
  width:95%;
}

.leftcol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.middlecol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.colrow {
  margin: 8px;
  flex: 1;
}

.data-flex-row{
  display: flex;
  flex-direction: row;
}

.data-flex-cell{
  flex: 1;
}

h5{
  margin-top: 5px;
  margin-bottom: 5px;
}

h4{
  margin-top: 4px;
  margin-bottom: 4px;
}
.e-input-group:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left).e-disabled,
.e-input-group.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error).e-disabled
  .e-input-in-wrap,
.e-input-group
  .e-control-wrapper:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left)
  .e-disabled,
.e-input-group.e-control-wrapper.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error)
  .e-disabled
  .e-input-in-wrap {
  border-bottom-color: black !important;
}

.e-btn.e-info:disabled, .e-css.e-btn.e-info:disabled {
    background-color: rgba(0, 0, 0, 0.12)  !important;
    border-color: transparent;
    box-shadow: none;
    color: rgba(0, 0, 0, 0.26);
}

.disabled-text {
  background-color: #eeeeee;
}

.left-grid {
  display: grid;
  align-content: space-between;
  margin: 10px;
  flex: 4;
}

</style>
